import { EProblemReportSortBy, EProblemReportSortOrder } from '@constants';
import { TFunction } from 'i18next';

export const getSortOrder = (
  columnSortBy: EProblemReportSortBy,
  currentSortBy?: EProblemReportSortBy,
  currentSortOrder?: EProblemReportSortOrder
): 'ascend' | 'descend' | null => {
  if (currentSortBy !== columnSortBy) return null;
  return currentSortOrder === EProblemReportSortOrder.ASC ? 'ascend' : 'descend';
};

export const getSortTooltip = (
  columnSortBy: EProblemReportSortBy,
  currentSortBy: EProblemReportSortBy | undefined,
  currentSortOrder: EProblemReportSortOrder | undefined,
  t: TFunction<['DefaultTranslations' | 'ProblemReportsTranslations']>
): string => {
  const isActiveColumn = currentSortBy === columnSortBy;

  if (!isActiveColumn) {
    const tooltipMap: Record<EProblemReportSortBy, string> = {
      [EProblemReportSortBy.TOTAL_REPORTS]: t('ProblemReportsTranslations:SORT_BY_TOTAL_REPORTS'),
      [EProblemReportSortBy.NOT_REVIEWED_COUNT]: t(
        'ProblemReportsTranslations:SORT_BY_NOT_REVIEWED'
      ),
      [EProblemReportSortBy.IN_REVIEW_COUNT]: t('ProblemReportsTranslations:SORT_BY_IN_REVIEW'),
      [EProblemReportSortBy.REVIEWED_COUNT]: t('ProblemReportsTranslations:SORT_BY_REVIEWED'),
      [EProblemReportSortBy.CREATION_DATE]: t('ProblemReportsTranslations:SORT_BY_CREATION_DATE')
    };
    return tooltipMap[columnSortBy];
  }

  if (columnSortBy === EProblemReportSortBy.CREATION_DATE) {
    return currentSortOrder === EProblemReportSortOrder.DESC
      ? t('ProblemReportsTranslations:SORT_CREATION_DATE_ASC')
      : t('ProblemReportsTranslations:SORT_CREATION_DATE_DESC');
  }

  return currentSortOrder === EProblemReportSortOrder.DESC
    ? t('ProblemReportsTranslations:SORT_ASC')
    : t('ProblemReportsTranslations:SORT_DESC');
};
